import { Menu, MenuItem } from '@affine/component';
import { STREAMLAIN_DROPDOWN_MENU_OFFSET } from '@affine/core/components/dropdown-panel-chrome/chrome';
import { RadixDropdownPanelChrome } from '@affine/core/components/dropdown-panel-chrome/radix-chrome';
import { MenuItem as SidebarMenuItem } from '@affine/core/modules/app-sidebar/views';
import { HelpActionsService } from '@affine/core/modules/help-actions';
import { websiteLocaleOf } from '@affine/env/website';
import { useI18n } from '@affine/i18n';
import {
  CloudBubbleIcon,
  ContactWithUsIcon,
  HelpCenterIcon,
  HelpIcon,
  NewIcon,
} from '@blocksuite/icons/rc';
import { useService } from '@toeverything/infra';
import { useRef, useState } from 'react';

export const HelpButton = () => {
  const t = useI18n();
  const locale = websiteLocaleOf(t.language);
  const actions = useService(HelpActionsService);
  const triggerRef = useRef<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);
  const run = (action: () => void) => {
    setOpen(false);
    action();
  };

  return (
    <Menu
      rootOptions={{ open, onOpenChange: setOpen }}
      contentOptions={{
        side: 'right',
        align: 'start',
        sideOffset: STREAMLAIN_DROPDOWN_MENU_OFFSET,
        collisionPadding: 8,
      }}
      items={
        <RadixDropdownPanelChrome triggerRef={triggerRef}>
          <MenuItem
            prefixIcon={<ContactWithUsIcon />}
            onClick={() => run(() => actions.reportBug())}
          >
            {t['com.streamlain.help.report-bug']()}
          </MenuItem>
          <MenuItem
            prefixIcon={<HelpIcon />}
            onClick={() => run(() => actions.submitIdea())}
          >
            {t['com.streamlain.help.submit-idea']()}
          </MenuItem>
          <MenuItem
            prefixIcon={<CloudBubbleIcon />}
            onClick={() => run(() => actions.openStatus(locale))}
          >
            {t['com.streamlain.help.system-status']()}
          </MenuItem>
          <MenuItem
            prefixIcon={<NewIcon />}
            onClick={() => run(() => actions.openReleaseNotes(locale))}
          >
            {t['com.streamlain.help.release-notes']()}
          </MenuItem>
          <MenuItem
            prefixIcon={<HelpCenterIcon />}
            onClick={() => run(() => actions.openPlatformDocs(locale))}
          >
            {t['com.streamlain.help.platform-docs']()}
          </MenuItem>
        </RadixDropdownPanelChrome>
      }
    >
      <SidebarMenuItem
        ref={triggerRef}
        icon={<HelpIcon />}
        data-testid="sidebar-help-button"
      >
        {t['com.streamlain.help.menu']()}
      </SidebarMenuItem>
    </Menu>
  );
};
